<mat-divider></mat-divider>

<div class="login">
  <h2>Sign In</h2>
  <div id="firebaseui-auth-container" class="auth-container">
  </div>
</div>
